import { css } from "styled-components"
import { breakpoints } from "utils/mixins"

import {
  fontBody,
  fontHeading,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
} from "./fonts"

/**
 * Type ramps built on the tokens in `fonts.js`.
 *
 * Sizes come straight from the scale (rem values), so they respond to the
 * root font-size rather than being hard-converted to px. Headings use
 * Montserrat, everything else Inter.
 */

export const h1 = css`
  font-family: ${fontHeading};
  font-weight: ${fontWeight.heading.black};
  font-size: ${fontSize["4xl"]};
  line-height: ${lineHeight.tight};
  letter-spacing: ${letterSpacing.tight};
  margin: 0 0 1.25rem;

  @media ${breakpoints.tablet} {
    font-size: ${fontSize["5xl"]};
  }

  @media ${breakpoints.laptop} {
    font-size: ${fontSize["6xl"]};
  }
`

export const h2 = css`
  font-family: ${fontHeading};
  font-weight: ${fontWeight.heading.bold};
  font-size: ${fontSize["3xl"]};
  line-height: ${lineHeight.snug};
  letter-spacing: ${letterSpacing.tight};
  margin-bottom: 1rem;

  @media ${breakpoints.tablet} {
    font-size: ${fontSize["4xl"]};
  }

  @media ${breakpoints.laptop} {
    font-size: ${fontSize["5xl"]};
  }
`

export const h3 = css`
  font-family: ${fontHeading};
  font-weight: ${fontWeight.heading.semibold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.snug};
  letter-spacing: ${letterSpacing.normal};

  @media ${breakpoints.laptop} {
    font-size: ${fontSize["2xl"]};
  }
`

export const h4 = css`
  font-family: ${fontHeading};
  font-weight: ${fontWeight.heading.semibold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.normal};
  letter-spacing: ${letterSpacing.normal};
`

export const h5 = css`
  font-family: ${fontBody};
  font-weight: ${fontWeight.body.semibold};
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.normal};
  letter-spacing: ${letterSpacing.wider};
  text-transform: uppercase;
`

export const p = css`
  font-family: ${fontBody};
  font-weight: ${fontWeight.body.regular};
  font-size: ${fontSize.base};
  line-height: ${lineHeight.relaxed};

  @media ${breakpoints.laptop} {
    font-size: ${fontSize.lg};
  }
`

/** Small uppercase label above a heading. */
export const kicker = css`
  font-family: ${fontBody};
  font-weight: ${fontWeight.body.semibold};
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.normal};
  letter-spacing: ${letterSpacing.wider};
  text-transform: uppercase;
`
